export const roundAllowZero = (time: number): number => {
    return Math.ceil(Number.isNaN(time) ? 0 : time);
};
